/**
 * loadSidebar sets the state of the sidebar by checking the localStorage for the state, and setting the class 'is-sidebar-open' accordingly.
 *
 * Related:
 * - toggleSidebar.js included in toolkit.js
 */

function loadSidebar () {
	const sidebarIsOpenClass = 'is-sidebar-open';

	const localStorageStr = 'isSidebarOpen';

	/* Get sidebar state from session */
	const isSidebarOpen = localStorage.getItem(localStorageStr);
	if (isSidebarOpen != null) {
		document.body.classList.add(sidebarIsOpenClass);
	} else {
		document.body.classList.remove(sidebarIsOpenClass);
	}
	$(function () {
		$('.sidebar ul.submenu-list').each(function () {
			var menuitems = $('li', this);
			var $ael = $(this).prev();
			$ael.toggleClass('has-menu', menuitems.length > 0);
			if (menuitems.length == 0) {
				$ael.removeClass('is-open');
			}
		});
	});
}
loadSidebar();
